import { taxAxios } from "@/utils/taxAxios";

export const taxAuth = (params, serialNo) => {
  return taxAxios.post(`/api/dbc/taxation/taxAuth?serialNo=${serialNo}`, params);
};

/** 通用税局授权，即不是电子税局授权类的，大象、微风企等 */
export const commonTaxAuthorization = (params) => {
  return taxAxios.get(`/api/dbc/taxation/authorization`, { params });
};

/** 获取订单采集状态 */
export const checkoutTaxAuthOrderCollectionStatus = (serialNo) => {
  const params = { serialNo };
  return taxAxios.get(`/api/dbc/taxation/taxAuthOrderCollectionStatus`, { params });
};

/** 获取插件配置信息 */
export const getPluginConfig = (taxType) => {
  const params = { taxType };
  return taxAxios.get("/api/dbc/taxation/pluginConfig", { params });
};

/** 获取授权状态 */
export const getAuthStatus = (serialNo) => {
  const params = { serialNo };
  return taxAxios.get("/api/dbc/taxation/authStatus", { params });
};

/** 获取已开通身份列表 */
export const getProvinceList = () => {
  return taxAxios.post("/api/dbc/taxation/taxBureau");
};

/** 更新订单税局省份 */
export const updateTaxOrderBureau = (params) => {
  return taxAxios.put("/api/dbc/taxation/updateTaxOrderBureau", params);
};

/** 电子税务局（企业）获取二维码 */
export const getEnterpriseQrCode = (params) => {
  return taxAxios.get("/api/dbc/taxation/getEnterpriseQrCode", { params });
};

/** 个人税务局获取二维码 */
export const getPersonalQrCode = (params) => {
  return taxAxios.get("/api/dbc/taxation/getPersonalQrCode", { params });
};

/** 电子税务局（企业）二维码-税局授权状态查询 */
export const getEnterpriseQrCodeStatus = (params) => {
  return taxAxios.get("/api/dbc/taxation/enterpriseQrCodeStatus", { params });
};

/** 个人税务局二维码-税局授权状态查询 */
export const getPersonalQrCodeStatus = (params) => {
  return taxAxios.get("/api/dbc/taxation/personalQrCodeStatus", { params });
};

/** 验证是否需要跳转添加办税员页面 */
export const checkAddTaxOfficer = (serialNo) => {
  return taxAxios.get("/api/dbc/taxation/config/taxpayer", {
    params: { serialNo },
  });
};

/** 添加办税员 */
export const addTaxOfficer = (params) => {
  return taxAxios.post("/api/dbc/taxation/taxpayer", params);
};

/** 获取企业办税员添加确认的二维码 */
export const changeQrCode = (params) => {
  return taxAxios.get("/api/dbc/taxation/changeQRCode", { params });
};

/** 验证企业二维码是否扫码确认 */
export const verifyQrCode = (params) => {
  return taxAxios.post("/api/dbc/taxation/verifyQRCode", params);
};
/** 电子税务局-图形验证码校验(20251202) */
export const generateCaptcha = (params) => {
  return taxAxios.post("/api/dbc/taxation/captcha/generate", null, { params });
};

/** 电子税务局-获取图形验证码(20251202) */
export const checkCaptcha = (params) => {
  return taxAxios.post("/api/dbc/taxation/captcha/check/info", params);
};

